import { render } from "./NewLockerModal.vue?vue&type=template&id=6c04cb77"
import script from "./NewLockerModal.vue?vue&type=script&lang=js"
export * from "./NewLockerModal.vue?vue&type=script&lang=js"

import "./NewLockerModal.vue?vue&type=style&index=0&id=6c04cb77&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__